// extracted by mini-css-extract-plugin
var _1 = "EditingOrganizationSummary-module__buttons--_oyH1";
var _2 = "EditingOrganizationSummary-module__container--_haVO";
export { _1 as "buttons", _2 as "container" }
